import { useMemo } from 'react';
import { PromiseState } from 'react-refetch';

export default useExportURL;

/**
 * Construct a new URL object based on the current API request,
 * using the current host (base:port) as the base.
 *
 * @param {Object} promiseState react-refetch promiseState
 * @param {Object=} setters keys are the params to overide with the values
 *
 * @returns {String} url to export the current request as CSV
 */
function useExportURL(promiseState: PromiseState<any>, setters?: any): string {
  const exportURL = useMemo(() => {
    if ('request' in promiseState?.meta) {
      const url = new URL(
        promiseState.meta.request.url,
        window.location.origin
      );

      // set the download query param to true
      url.searchParams.set('download', 'true');

      // add or override params
      if (setters && Object.getOwnPropertyNames(setters).length > 0) {
        Object.entries(setters).forEach(([param, value]: [string, any]) => {
          url.searchParams.set(param, value.toString());
        });
      }

      return url.toString();
    }
    return '';
  }, [promiseState, setters]);

  return exportURL;
}
